import {createAction} from 'redux-act'

export const setIncomeCategoryModalVisible = createAction('SET_INCOME_CATEGORY_FORM_VISIBLE')
export const setIncomeCategoryForm = createAction('SET_INCOME_CATEGORY_FORM')

export const setSpendingCategoryModalVisible = createAction('SET_SPENDING_CATEGORY_FORM_VISIBLE')
export const setSpendingCategoryForm = createAction('SET_SPENDING_CATEGORY_FORM')

export const setSubcategoryModalVisible = createAction('SET_SUBCATEGORY_FORM_VISIBLE')
export const setSubcategoryForm = createAction('SET_SUBCATEGORY_FORM')



